import { call, put } from 'redux-saga/effects'
import { INearIntentsToken, fetchNearIntentsTokens } from 'services/nearIntents'
import { fetchTokensFailure, fetchTokensSuccess } from './reducer'

export function* fetchNearIntentsTokensSaga() {
	try {
		const tokens: INearIntentsToken[] = yield call(fetchNearIntentsTokens)
		yield put(fetchTokensSuccess(tokens))
	} catch (e) {
		const error = e as { message: string }
		yield put(fetchTokensFailure(error.message ?? 'Failed to load tokens'))
	}
}
